import React, { useState } from "react";
import "./GlobalReach.css";

const REGIONS = [
  {
    name: "USA",
    tag: "North America",
    icon: "building-skyscraper",
    desc: "Driving digital transformation, AI strategy, and operating model modernization for enterprises across North America.",
  },
  {
    name: "Europe",
    tag: "EMEA",
    icon: "world",
    desc: "Supporting regulatory-driven innovation, data platforms, and performance transformation across EU markets.",
  },
  {
    name: "Middle East",
    tag: "Gulf Region",
    icon: "diamond",
    desc: "Enabling national vision programs, smart infrastructure, and enterprise-scale digital programs.",
  },
  {
    name: "APAC",
    tag: "Asia Pacific",
    icon: "chart-line",
    desc: "Accelerating cloud, AI, and business transformation across high-growth Asia Pacific economies.",
  },
  {
    name: "India",
    tag: "South Asia",
    icon: "cpu",
    desc: "Innovation hub delivering AI, data engineering, digital core, and transformation execution capabilities.",
  },
];

const STATS = [
  { num: "5", label: "Regions" },
  { num: "10+", label: "Countries" },
  { num: "20+", label: "Enterprise clients" },
];

function RegionCard({ region }) {
  const [hovered, setHovered] = useState(false);

  return (
    <div
      className={`gr-card${hovered ? " gr-card--hovered" : ""}`}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="gr-icon-wrap">
        <i className={`ti ti-${region.icon}`} aria-hidden="true" />
      </div>
      <h2 className="gr-card-title">{region.name}</h2>
      <p className="gr-card-desc">{region.desc}</p>
      <span className="gr-tag">{region.tag}</span>
    </div>
  );
}

export default function GlobalReach() {
  return (
    <div className="gr-wrap">
      {/* HERO */}
      <section className="gr-hero">
        <div className="gr-hero-ring gr-hero-ring--outer" aria-hidden="true" />
        <div className="gr-hero-ring gr-hero-ring--inner" aria-hidden="true" />

        <p className="gr-eyebrow">Global Presence</p>
        <h1 className="gr-hero-title">
          Worldwide<br />Reach
        </h1>
        <p className="gr-hero-sub">
          Delivering transformation programs across continents with deep
          regional expertise and global advisory excellence.
        </p>

        <div className="gr-stat-row">
          {STATS.map((s) => (
            <div key={s.label} className="gr-stat">
              <span className="gr-stat-num">{s.num}</span>
              <span className="gr-stat-lbl">{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* REGIONS */}
      <section className="gr-grid" aria-label="Regional offices">
        {REGIONS.map((region) => (
          <RegionCard key={region.name} region={region} />
        ))}
      </section>
    </div>
  );
}